<template>
  <form class="version version-2" name="step4_1">
    <input type="hidden" name="landing_type" value="cash">
    <div class="input-group_title">
      <h4>{{__t('Дані про працевлаштування')}}</h4>
    </div>
    <div class="form-wrap fw">
      <div class="input-field" style="order: -1">
        <label><p>{{__t('Посада на поточному місці роботи')}}</p>
          <div class="select-wrapper">
            <select name="client_position" class="required activities">
              <option value="default">{{__t('Виберіть посаду')}}</option>
              <option :value="position.code" v-for="position in positions">{{position.title}}</option>
            </select>

            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>
      </div>
      <div class="input-field" style="order: 2">
        <label><p>{{__t('Коли почали працювати на поточному місці')}}</p></label>

        <div class="input-wrap fw">
          <div class="select-wrapper">
            <select name="month" class="required ">
              <option value="default">{{__t('Місяць')}}</option>
              <option :value="index+1" :key="index" v-for="(item , index) in months">{{item}}</option>
            </select>

            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
          <input type="tel" name="year" placeholder="Рік" v-mask="'####'">
        </div>
      </div>
      <div class="input-field" v-show="type_activity == 3" style="order: 4">
        <label>
          <p>{{__t('Коли вийшли на пенсію?')}}</p>
          <div class="input-wrap">
            <input type="tel" name="employer_last_work_date" placeholder="ДД.ММ.РРРР" v-mask="'##.##.####'"
                   @input="hideBackEndError">
            <div v-show="typeof errorValidation.employer_last_work_date !== 'undefined'">
              <label class="error_back" style="color: red"
                     v-for="error in errorValidation.employer_last_work_date">{{error}}</label>
            </div>
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Подсказка дата выхода на пенсию')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div class="input-group_title">
      <h4>{{__t('Дані про доходи')}}</h4>
    </div>
    <div class="form-wrap_group fw">
      <div class="input-field">
        <label>
          <p>{{__t('Офіційний місячний дохід, грн')}}</p>
          <div class="input-wrap">
            <input type="number" name="official_income"
                  :placeholder="__t('Введіть сумму')" v-numericOnly pattern="^[0-9]+$"
                  v-model="official_income">
            <div class="input-info_btn input-info-wrap">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Підказка офіційний місячний дохід - cash - частина-1')}}</p>
                <p>{{__t('Підказка офіційний місячний дохід - cash - частина-2')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Сукупний місячний дохід, грн')}}</p>
          <div class="input-wrap">
            <input type="number" name="unconfirmed_income" :placeholder="__t('Введіть сумму')"
                  v-numericOnly pattern="^[0-9]+$"
                  v-model="unconfirmed_income">
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Подсказка общий месячный доход')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div class="input-group_title">
      <h4>{{__t('Дані про роботодавця')}}</h4>
    </div>
    <div class="form-wrap fw">
      <div class="input-field fw">
        <label>
          <p>{{__t('Назва організації')}}</p>
          <div class="input-wrap">
            <input type="text" name="employer_name" v-apartment :placeholder="__t('Назва організації')">
          </div>
        </label>
      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Сфера діяльності організації')}}</p>
          <div class="select-wrapper">
            <select name="field_of_activity" class="required activities">
              <option value="default">{{__t('Оберіть cферу діяльності організації')}}</option>
              <option :value="option.code" v-for="option in activities">{{option.title}}</option>
            </select>

            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>
      </div>
      <div class="input-field fw">
        <label>
          <p>{{__t('Код ЄДРПОУ')}}</p>
          <div class="input-wrap">
            <input type="tel" name="employer_id" v-mask="employer_id_mask" data-is-inn="0" :placeholder="__t('ЄДРПОУ')">
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p v-html="__t('Подсказка ЄДРПОУ')"></p>
              </div>
            </div>
          </div>
        </label>

      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Робочий номер телефону')}}</p>
          <div class="input-wrap">
            <input type="tel" name="work_phone"
                  :placeholder="__t('Номер телефону')"
                  v-mask="'+380#########'"
                  inputmode="tel">
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p v-html="__t('Подсказка номер телефону')"></p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div class="button-group">
      <button type="button"
              @click.submit.prevent="goBack"
              class="popup-button btn green-btn colored-btn">
        {{__t('Повернутись назад')}}
      </button>
        <div class="button-wrapper page-bottom ">
          <button type="submit" class="btn red-btn">{{__t('Відправити заявку')}}</button>
        </div>
    </div>

  </form> <!--Найманий працівник     1-->
</template>

<script>
    export default {
        name: "type_activity_1",
        props: [
            'months',
            'positions',
            'employerownership',
            'regions',
            'activities',
            'type_activity'
        ],
        data() {
            return {
                changeWork: "false",
                errorValidation: {},
                employer_property: 'default',
                is_inn: false,
                official_income: '',
                unconfirmed_income: '',
            }
        },

        computed: {
          employer_id_mask() {
            return this.is_inn ? '##########' : '########';
          }
        },

        watch: {
          employer_property(newVal) {
            if (newVal != 29) {
              this.is_inn = false;
              document.querySelector('[data-is-inn]').dataset.isInn = 0;
            } else {
              this.is_inn = true;
              document.querySelector('[data-is-inn]').dataset.isInn = 1;
            }
          },
          official_income(newVal) {
            this.official_income = newVal.replace(/\D/g, '') || '';
          },
          unconfirmed_income(newVal) {
            this.unconfirmed_income = newVal.replace(/\D/g, '') || '';
          }
        },

        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            hideBackEndError(el) {
                this.errorValidation.employer_last_work_date = [];
            },
            goBack() {
                this.$emit('goback');
                return false;
            },
            goNext() {
                this.$emit('gonext');
                return false;
            },
            changeRuleId() {
              this.rule_employer_id = {
                edrpo: false,
                number: true,
                minlength: 10,
              }
              console.log('this.rule_employer_id: ', this.rule_employer_id);
            },
            validation: function () {
                let self = this;


                let form = $('.version-2').validate({
                    rules: {

                        work_phone: {
                            required: true,
                            mobileValidateLength: true,
                        },
                        employer_industry_type: {
                            selectRequired: 'default',
                        },

                        client_position: {
                            selectRequired: 'default',
                        },
                        month: {
                            selectRequired: 'default',
                            startWork: true
                        },
                        changeWork: {
                            selectRequired: 'default',
                        },
                        employer_property_form: {
                            selectRequired: 'default',
                        },
                        official_income: {
                            required: true,
                        },
                        unconfirmed_income: {
                            required: true,
                        },
                        year: {
                            required: true,
                            regDay: true
                        },
                        employer_last_work_date: {
                            required: true,
                            regDay: true
                        },
                        employer_name: {
                            required: true,
                            maxlength: 160
                        },

                        emp_region: {
                            selectRequired: 'default',
                        },
                        employer_region: {
                            selectRequired: 'default',
                        },
                        employer_work_changes: {
                            required: true,
                        },
                        employer_id: {
                          edrpoinn: true,
                        },

                    },
                    messages: {

                        work_phone: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            mobileValidateLength: __t('Номер телефону складається з 12 цифр'),
                        },
                        employer_industry_type: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },

                        client_position: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },
                        month: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },
                        changeWork: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },
                        employer_property_form: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },
                        employer_last_work_date: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            normalDate: __t("Виправте дату"),
                        },
                        year: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            normalDate: __t("Виправте дату"),
                        },
                        official_income: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                        unconfirmed_income: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                        employer_name: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            maxlength: __t("Не більше 160 символiв"),
                        },

                        emp_region: {
                            selectRequired: __t("Оберіть один з варіантів"),
                        },
                        employer_work_changes: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                    },
                    submitHandler: function (form) {
                        self.$emit('openPreloader');
                        if (self.type_activity >= 5 && self.type_activity <= 9) {
                            self.showPopupError();
                            return;
                        }

                        var data = $('[name=step4_1]').serializeArray();

                        jQuery.ajax({
                          headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                          },
                            data: data,
                            type: "POST",
                            url: '/cash/step4',
                            cache: false,
                            dataType: "json",
                            success: function (response) {
                                if (response.status == 'refusing') {
                                    self.$emit('error');
                                } else if (response.status == 'callback') {
                                    self.$emit('call');
                                } else {
                                    self.$emit('success');
                                }
                                self.$emit('closePreloader');
                                // self.$emit('returnbegin');
                            },
                            error: function (error) {
                                self.errorValidation = error.responseJSON;
                                self.$emit('closePreloader');
                            }
                        });

                    }
                });
            },
        },
        mounted() {
            this.validation();

            $('.input-info_btn').on('mouseover', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "visible";
            });


            $('.input-info_btn').on('mouseout', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "hidden";
            });
        }
    }
</script>

<style>
.input-info-wrap {
  z-index: 2;
}
.input-info-wrap .input-info_popup {
  width: 200px;
}
</style>
